<div class="modal-overlay" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ 'pages.productConfig.modal.authorization.title' | i18n }}</h2>
    </div>

    <!-- Content -->
    <div class="modal-content">
      <p class="modal-description">
        {{ 'pages.productConfig.modal.authorization.description' | i18n }}
      </p>

      <div class="modal-instructions">
        <h3 class="instructions-title">{{ 'pages.productConfig.modal.authorization.instructionsTitle' | i18n }}</h3>
        <ol class="instructions-list">
          <li [innerHTML]="'pages.productConfig.modal.authorization.step1' | i18n"></li>
          
          <li [innerHTML]="'pages.productConfig.modal.authorization.step2' | i18n: { domain: domain }"></li>
          
          <li>{{ 'pages.productConfig.modal.authorization.step3' | i18n }}</li>
        </ol>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="onClose()">
        {{ 'shared.buttons.cancel' | i18n }}
      </button>
      <button type="button" class="btn-authorize" (click)="onAuthorize()">
        {{ 'pages.productConfig.modal.authorization.authorizeButton' | i18n }}
        <umkt-icon [icon]="{ name: 'launch', type: 'material-icons' }" size="sm"></umkt-icon>
      </button>
    </div>
  </div>
</div>